import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const StudentTable = ({
  students,
  lazyParams,
  totalRecords,
  loading,
  onPage,
  onSort,
  handleViewStudent,
  handleViewFeeDetails,
  handleEditStudent,
  handleDeleteStudent,
  handleAddTransport
}) => {

  const studentNameTemplate = (row) => {
    const fullName = `${row.firstName || ''} ${row.lastName || ''}`.trim();
    return (
      <div className="flex items-center space-x-3">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-gray-900 truncate">{fullName || 'N/A'}</div>
        </div>
      </div>
    );
  };

  const admissionTemplate = (row) => (
    <div className="text-xs">
      <div className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
        <i className="pi pi-id-card mr-2"></i>
        {row.admissionNumber || 'N/A'}
      </div>
    </div>
  );

  const classTemplate = (row) => (
    <div className=" text-sm">
      <div className="inline-flex items-center px-2 py-0.5 bg-indigo-50 rounded-md border border-indigo-100">
        <div className="font-semibold text-indigo-900">{row.className || 'N/A'}</div>
        <div className="ml-2 text-indigo-600 text-xs">{row.sectionName || ''}</div>
      </div>
    </div>
  );

  const actionsTemplate = (row) => (
    <div className="flex items-center justify-center space-x-2">
      <Button icon="pi pi-eye" className="p-button-rounded p-button-text p-button-sm hover:bg-green-50 text-blue-600 border-2 border-blue-200 hover:border-blue-300 transition-all duration-200" onClick={() => handleViewStudent(row)} tooltip="View Details" tooltipOptions={{ position: 'top' }} />
      {/* <Button icon="pi pi-dollar" className="p-button-rounded p-button-text p-button-sm hover:bg-yellow-50 text-yellow-600 border-2 border-yellow-200 hover:border-yellow-300 transition-all duration-200" onClick={() => handleViewFeeDetails(row)} tooltip="Fee Details" tooltipOptions={{ position: 'top' }} /> */}
      <Button label="₹" onClick={() => handleViewFeeDetails(row)} tooltip="Fee Details" tooltipOptions={{ position: 'top' }}
        className=" w-10 h-10  rounded-full  flex items-center justify-center  bg-yellow-500 hover:bg-yellow-600  text-white font-semibold  shadow-md  transition-all duration-200" />
         <Button icon="pi pi-car" className="p-button-rounded p-button-text p-button-sm hover:bg-purple-50 text-purple-600 border-2 border-purple-200 hover:border-purple-300 transition-all duration-200" onClick={() => handleAddTransport(row)} tooltip="Add Transport" tooltipOptions={{ position: 'top' }} />
      <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-sm hover:bg-green-50 text-green-600 border-2 border-green-200 hover:border-green-300 transition-all duration-200" onClick={() => handleEditStudent(row)} tooltip="Edit Student" tooltipOptions={{ position: 'top' }} />
      <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-sm hover:bg-red-50 text-red-600 border-2 border-red-200 hover:border-red-300 transition-all duration-200" onClick={() => handleDeleteStudent(row)} tooltip="Delete Student" tooltipOptions={{ position: 'top' }} />
     
    </div>
  );

  const loadingTemplate = (
    <div className="flex justify-center items-center py-12">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <i className="pi pi-user text-blue-600 text-xl"></i>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <span className="text-lg font-bold text-gray-900">Loading Students</span>
          <span className="text-sm text-gray-500 italic">Please wait while we fetch the directory...</span>
        </div>
      </div>
    </div>
  );

  return (
    <DataTable value={students} lazy dataKey="id" paginator first={lazyParams.first} rows={lazyParams.rows}
      totalRecords={totalRecords} onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} loading={loading}
      loadingIcon="pi pi-spin pi-spinner"
      emptyMessage={<div className="text-center py-8">No students found</div>} rowsPerPageOptions={[5, 10, 25, 50]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} students" responsiveLayout="scroll" showGridlines stripedRows size="small">
      <Column field="id" header={<div className="flex text-xs"><i className="pi pi-id-card mr-1 text-xs"></i>Student ID</div>} body={admissionTemplate} sortable />
      <Column field="firstName" header={<div className="flex items-center text-xs"><i className="pi pi-user mr-1 text-xs"></i>Name</div>} body={studentNameTemplate} sortable />
      <Column field="classSection" header={<div className="flex items-center justify-center text-xs"><i className="pi pi-book mr-1 text-xs"></i>Class/Section</div>} body={classTemplate} />
      <Column header={<div className="flex items-center text-xs"><i className="pi pi-cog mr-1 text-xs"></i>Actions</div>} body={actionsTemplate} />
    </DataTable>
  );
};

export default StudentTable;
